const ApiVersion = '/api/v1.0'
const ApiRoutes = {
    // Authentication
    Login: ApiVersion + '/auth/login',
    Project: ApiVersion + '/project',
    District: ApiVersion + '/district',
    InvestorCategory: ApiVersion + '/investor/category',
    Unit: ApiVersion + '/unit',
    RawMaterial: ApiVersion + '/raw/material',
    ExpenseCategory: ApiVersion + '/expense/category',
    IncomeCategory: ApiVersion + '/income/category',
    Bank: ApiVersion + '/bank',
    ShareHolder: ApiVersion + '/shareholder',
    Expense: ApiVersion + '/expense',
    Asset: ApiVersion + '/asset',
    Income: ApiVersion + '/income',
    Report: ApiVersion + '/report',
    Supplier: ApiVersion + '/supplier',
    Dashboard: ApiVersion + '/dashboard',
    Interest: ApiVersion + '/interest',
    Contact: ApiVersion + '/contact',
    Customer: ApiVersion + '/customer',
    SpecialExpense: ApiVersion + '/specialExpense',
    CashReceived: ApiVersion + '/cashReceived',
    Order: ApiVersion + '/order',
    Purchase: ApiVersion + '/purchase',
    //Department
    //Designation
    AddDesignation: ApiVersion + '/designation/save',
    EditDesignation: ApiVersion + '/designation/update',
    SingleDesignation: ApiVersion + '/designation/single',
    DeleteDesignation: ApiVersion + '/designation/delete',
    ListDesignation: ApiVersion + '/designation/list',
    DesignationExportExcel: ApiVersion + '/designation/export/excel',
    DesignationExportPdf: ApiVersion + '/designation/export/pdf',

    AddSlot: ApiVersion + '/slot/save',
    EditSlot: ApiVersion + '/slot/update',
    SingleSlot: ApiVersion + '/slot/single',
    DeleteSlot: ApiVersion + '/slot/delete',
    ListSlot: ApiVersion + '/slot/list',
    SlotExportExcel: ApiVersion + '/slot/export/excel',
    SlotExportPdf: ApiVersion + '/slot/export/pdf',

    //Construction
    AddConstruction: ApiVersion + '/construction/save',
    EditConstruction: ApiVersion + '/construction/update',
    SingleConstruction: ApiVersion + '/construction/single',
    DeleteConstruction: ApiVersion + '/construction/delete',
    ListConstruction: ApiVersion + '/construction/list',
    ConstructionExportExcel: ApiVersion + '/construction/export/excel',
    ConstructionExportPdf: ApiVersion + '/construction/export/pdf',

    AddArea: ApiVersion + '/area/save',
    EditArea: ApiVersion + '/area/update',
    SingleArea: ApiVersion + '/area/single',
    DeleteArea: ApiVersion + '/area/delete',
    ListArea: ApiVersion + '/area/list',
    AreaExportExcel: ApiVersion + '/area/export/excel',
    AreaExportPdf: ApiVersion + '/area/export/pdf',


    //Employee
    AddEmployee: ApiVersion + '/employee/save',
    EditEmployee: ApiVersion + '/employee/update',
    SingleEmployee: ApiVersion + '/employee/single',
    DeleteEmployee: ApiVersion + '/employee/delete',
    ListEmployee: ApiVersion + '/employee/list',
    SearchEmployee: ApiVersion + '/employee/search',
    LastIdEmployee: ApiVersion + '/employee/lastId',
    EmployeeExportExcel: ApiVersion + '/employee/export/excel',
    EmployeeExportPdf: ApiVersion + '/employee/export/pdf',
    EmployeeSingleExportPdf: ApiVersion + '/employee/export/singlePdf',
    CostingItem: ApiVersion + '/costing/item',
    RawMaterialProfit: ApiVersion + '/raw-material-profit',
    BankWithdraw: ApiVersion + '/bank-withdraw',
    CustomerReference: ApiVersion + '/customer-reference',
    SalesPerson: ApiVersion + '/sales-person',
    ProjectSlot: ApiVersion + '/project-slot',
};

export default ApiRoutes;
